import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field, GradButton, fmtMoney } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import { useAuth } from "@/context/AuthContext";
import { CARI_TIP, PARA, ONAY_KURAL } from "@/lib/perms";
import { BayiKullanicilari } from "@/components/BayiKullanicilari";
import api, { errMsg } from "@/lib/api";

export const CARI_BOS = { kod: "", unvan: "", tip: "musteri", grup: "", vergi_dairesi: "", vergi_no: "", yetkili: "", telefon: "", email: "",
  adres: "", il: "", ilce: "", gps_lat: null, gps_lng: null, temsilci_id: null, para_birimi: "TRY", risk_limiti: 0, acilis_bakiye: 0,
  vade_gun: 0, kar_yuzde: 20, iskonto_yuzde: 0, fatura_bakiye_goster: false, ozel_fiyatlar: [], anlasmali: false, efatura_mukellef: false, teslim_eposta: false, onay_kurali: null, aktif: true, notlar: "" };

const Ekstre = ({ id }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    if (id) api.get(`/cariler/${id}/ekstre`).then((r) => setD(r.data));
  }, [id]);
  if (!id) return <p className="text-sm text-muted-foreground py-6">Ekstre için önce cariyi kaydedin.</p>;
  if (!d) return null;
  return (
    <div data-testid="cari-ekstre">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-3 text-xs">
        {[["Bakiye", d.risk.bakiye], ["Açık sipariş", d.risk.acik_siparis], ["Portföy çek/senet", d.risk.portfoy], ["Risk kullanımı", d.risk.kullanim]].map(([l, v]) => (
          <div key={l} className="rounded-lg bg-white/5 p-2"><div className="text-muted-foreground">{l}</div><div className="font-mono font-semibold" data-testid={`ekstre-${l}`}>{fmtMoney(v)}</div></div>
        ))}
      </div>
      <div className="max-h-[40vh] overflow-y-auto erp-scroll space-y-1">
        <div className="grid grid-cols-12 gap-2 text-[10px] uppercase tracking-wider text-muted-foreground pb-1">
          <span className="col-span-2">Tarih</span><span className="col-span-4">Açıklama</span><span className="col-span-2 text-right">Borç</span><span className="col-span-2 text-right">Alacak</span><span className="col-span-2 text-right">Bakiye</span>
        </div>
        {d.satirlar.map((r, i) => (
          <div key={i} className="grid grid-cols-12 gap-2 text-xs border-b border-white/5 py-1.5">
            <span className="col-span-2 font-mono text-muted-foreground">{r.tarih}</span><span className="col-span-4">{r.aciklama} <span className="font-mono text-muted-foreground">{r.belge}</span></span>
            <span className="col-span-2 text-right font-mono text-red-400">{r.alacak ? fmtMoney(r.alacak) : ""}</span><span className="col-span-2 text-right font-mono text-emerald-400">{r.borc ? fmtMoney(r.borc) : ""}</span>
            <span className={`col-span-2 text-right font-mono font-semibold ${r.bakiye >= 0 ? "text-emerald-400" : "text-red-400"}`}>{fmtMoney(r.bakiye)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export const OzelFiyatlar = ({ form, setForm }) => {
  const { user } = useAuth();
  const [liste, setListe] = useState(null);
  useEffect(() => {
    if (form.id) api.get(`/cariler/${form.id}/fiyat-listesi`).then((r) => setListe(r.data));
  }, [form.id]);
  if (!form.id) return <p className="text-sm text-muted-foreground py-6">Özel fiyatları tanımlamak için önce cariyi kaydedin.</p>;
  if (!liste) return null;
  const ozel = Object.fromEntries(form.ozel_fiyatlar.map((o) => [o.urun_id, o.kar_yuzde]));
  const setKar = (uid, v) => setForm((f) => {
    const rest = f.ozel_fiyatlar.filter((o) => o.urun_id !== uid);
    return { ...f, ozel_fiyatlar: v === "" ? rest : [...rest, { urun_id: uid, kar_yuzde: Number(v) }] };
  });
  return (
    <div className="space-y-2 max-h-[45vh] overflow-y-auto erp-scroll" data-testid="ozel-fiyat-listesi">
      <p className="text-xs text-muted-foreground">Boş bırakılan ürünlerde genel kâr oranı (%{form.kar_yuzde}) uygulanır. Fiyat = maliyet × (1 + kâr %).</p>
      {liste.kalemler.map((k) => {
        const kar = ozel[k.urun_id] ?? form.kar_yuzde;
        const canli = k.cogs != null && k.cogs > 0 ? k.cogs * (1 + kar / 100) : k.fiyat_try;
        return (
          <div key={k.urun_id} className="grid grid-cols-12 gap-2 items-center text-sm" data-testid={`ozel-fiyat-${k.kod}`}>
            <span className="col-span-6 truncate"><span className="font-mono text-xs text-muted-foreground mr-2">{k.kod}</span>{k.ad}</span>
            <Input data-testid={`ozel-kar-${k.kod}`} type="number" disabled={user.role === "satis"} placeholder={`%${form.kar_yuzde}`} className="col-span-2 bg-white/5 h-8"
              value={ozel[k.urun_id] ?? ""} onChange={(e) => setKar(k.urun_id, e.target.value)} />
            <span className={`col-span-4 text-right font-mono ${canli < k.min_satis_fiyati ? "text-amber-400" : ""}`}>{fmtMoney(canli)}</span>
          </div>
        );
      })}
    </div>
  );
};

const Inp = ({ k, form, set, type = "text" }) => (
  <Input data-testid={`cari-${k}`} type={type} step="any" className="bg-white/5" value={form[k] ?? ""}
    onChange={(e) => set(k, type === "number" ? (e.target.value === "" ? null : Number(e.target.value)) : e.target.value)} />
);

export const CariDialog = ({ initial, temsilciler, onClose, onSaved }) => {
  const { user } = useAuth();
  const [form, setForm] = useState(initial);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const p = { form, set };
  const finansKilit = user.role === "satis";

  const save = async () => {
    try {
      const body = { ...form, risk_limiti: form.risk_limiti || 0, acilis_bakiye: form.acilis_bakiye || 0, kar_yuzde: form.kar_yuzde || 0, vade_gun: form.vade_gun || 0 };
      const { data } = form.id ? await api.put(`/cariler/${form.id}`, body) : await api.post("/cariler", body);
      toast.success("Cari kaydedildi");
      onSaved(data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass max-w-3xl max-h-[92vh] overflow-y-auto erp-scroll" data-testid="cari-dialog">
        <DialogHeader><DialogTitle className="font-head">{form.id ? form.unvan : "Yeni cari"}</DialogTitle></DialogHeader>
        <Tabs defaultValue="genel">
          <TabsList className="bg-white/5">
            <TabsTrigger value="genel" data-testid="cari-tab-genel">Genel</TabsTrigger>
            <TabsTrigger value="risk" data-testid="cari-tab-risk">Risk & Fiyat</TabsTrigger>
            <TabsTrigger value="ozel" data-testid="cari-tab-ozel">Ürüne özel kâr</TabsTrigger>
            <TabsTrigger value="ekstre" data-testid="cari-tab-ekstre">Ekstre</TabsTrigger>
            {form.tip !== "tedarikci" && <TabsTrigger value="bayi" data-testid="cari-tab-bayi">Bayi girişi</TabsTrigger>}
          </TabsList>
          <TabsContent value="genel" className="grid sm:grid-cols-3 gap-4 pt-2">
            <Field label="Ünvan *" className="sm:col-span-2"><Inp k="unvan" {...p} /></Field>
            <Field label="Kod (boş = otomatik)"><Inp k="kod" {...p} /></Field>
            <Field label="Tip"><SelectBox testid="cari-tip" value={form.tip} onChange={(v) => set("tip", v)} options={Object.entries(CARI_TIP).map(([value, label]) => ({ value, label }))} /></Field>
            <Field label="Grup (Bayi, Toptan…)"><Inp k="grup" {...p} /></Field>
            <Field label="Yetkili"><Inp k="yetkili" {...p} /></Field>
            <Field label="Vergi Dairesi"><Inp k="vergi_dairesi" {...p} /></Field>
            <Field label="Vergi No / TCKN"><Inp k="vergi_no" {...p} /></Field>
            <Field label="Telefon"><Inp k="telefon" {...p} /></Field>
            <Field label="E-posta"><Inp k="email" {...p} /></Field>
            <Field label="İl"><Inp k="il" {...p} /></Field>
            <Field label="İlçe"><Inp k="ilce" {...p} /></Field>
            <Field label="Adres" className="sm:col-span-3"><Inp k="adres" {...p} /></Field>
            <Field label="GPS enlem"><Inp k="gps_lat" type="number" {...p} /></Field>
            <Field label="GPS boylam"><Inp k="gps_lng" type="number" {...p} /></Field>
            <label className="flex items-end gap-2 text-sm pb-2"><Switch data-testid="cari-aktif" checked={form.aktif} onCheckedChange={(v) => set("aktif", v)} />Aktif</label>
            <label className="flex items-end gap-2 text-sm pb-2 sm:col-span-2"><Switch data-testid="cari-teslim-eposta" checked={!!form.teslim_eposta} onCheckedChange={(v) => set("teslim_eposta", v)} />Teslimde imzalı irsaliyeyi e-postayla gönder</label>
          </TabsContent>
          <TabsContent value="risk" className="grid sm:grid-cols-3 gap-4 pt-2">
            {finansKilit && <p className="sm:col-span-3 text-xs text-amber-400" data-testid="cari-finans-kilit">Risk limiti, bakiye ve kâr oranlarını yalnızca yönetici değiştirebilir.</p>}
            <fieldset disabled={finansKilit} className="contents">
            <Field label="Risk limiti (TL, 0 = tanımsız → onay)"><Inp k="risk_limiti" type="number" {...p} /></Field>
            <Field label="Açılış bakiyesi (TL, + alacaklıyız / − borçluyuz)"><Inp k="acilis_bakiye" type="number" {...p} /></Field>
            </fieldset>
            <Field label="Vade (gün)"><Inp k="vade_gun" type="number" {...p} /></Field>
            <Field label="Para birimi"><SelectBox testid="cari-para" value={form.para_birimi} onChange={(v) => set("para_birimi", v)} options={PARA} /></Field>
            <fieldset disabled={finansKilit} className="contents"><Field label="Genel kâr % (maliyet üzerine)"><Inp k="kar_yuzde" type="number" {...p} /></Field>
              <label className="flex items-end gap-2 text-sm pb-2"><Switch data-testid="cari-anlasmali" disabled={finansKilit} checked={!!form.anlasmali} onCheckedChange={(v) => set("anlasmali", v)} />Anlaşmalı müşteri (eksik direkt imalata)</label>
            </fieldset>
            <label className="flex items-end gap-2 text-sm pb-2"><Switch data-testid="cari-efatura" checked={!!form.efatura_mukellef} onCheckedChange={(v) => set("efatura_mukellef", v)} />e-Fatura mükellefi (değilse e-Arşiv kesilir)</label>
            {user.role !== "satis" && (
              <Field label="Satış temsilcisi">
                <SelectBox testid="cari-temsilci" value={form.temsilci_id || "yok"} onChange={(v) => set("temsilci_id", v === "yok" ? null : v)}
                  options={[{ value: "yok", label: "Temsilci yok (yönetici onaylar)" }, ...temsilciler.map((t) => ({ value: t.id, label: t.name }))]} />
              </Field>
            )}
            <Field label="Sipariş onay kuralı" className="sm:col-span-2">
              <fieldset disabled={finansKilit}><SelectBox testid="cari-onay-kurali" value={form.onay_kurali || "varsayilan"} onChange={(v) => set("onay_kurali", v === "varsayilan" ? null : v)}
                options={[{ value: "varsayilan", label: "Firma varsayılanı (Ayarlar)" }, ...Object.entries(ONAY_KURAL).map(([value, label]) => ({ value, label }))]} /></fieldset>
            </Field>
            <p className="sm:col-span-3 text-xs text-muted-foreground">Kurala takılan, limiti tanımsız veya minimum fiyatın altındaki siparişler (bayi portalından gelenler dahil) temsilcinin, temsilci yoksa yöneticinin onayına düşer. Diğerleri doğrudan işleme alınır.</p>
          </TabsContent>
          <TabsContent value="ozel" className="pt-2"><OzelFiyatlar form={form} setForm={setForm} /></TabsContent>
          <TabsContent value="ekstre" className="pt-2"><Ekstre id={form.id} /></TabsContent>
          <TabsContent value="bayi" className="pt-2"><BayiKullanicilari cari={form} /></TabsContent>
        </Tabs>
        <div className="flex justify-end gap-2 mt-2">
          <button onClick={onClose} className="px-5 py-2 rounded-full border border-white/10 text-sm hover:bg-white/5" data-testid="cari-iptal">Vazgeç</button>
          <GradButton onClick={save} data-testid="cari-kaydet">Kaydet</GradButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};
